import Client from '../../Client';
import Article from '../../Entities/Mobile/Articles/Article';
import GenericNamespaceHandler from '../../GenericNamespaceHandler';

export default class ArticlesNamespace extends GenericNamespaceHandler {
  namespace = 'mobile/articles';

  searchCall = '';

  createCall = 'create';

  updateCall = 'update';

  deleteCall = 'delete';

  archiveCall = 'archive';

  unarchiveCall = 'unarchive';

  searchRequiresBuildingId = true;

  responseEntity = Article;

  responseKey = 'article';

  cacheSearchResults = false;

  requiredFields = [];

  /** *
   * @param {Client} Client - instance of client
   */
  constructor(Client) {
    super(Client);
  }

  create(
    title,
    building_id,
    category_id,
    section_id,
    images,
    body,
    optional = {
      archived: undefined,
      button_text: undefined,
      featured: undefined,
      publish_date: undefined,
      website_url: undefined
    }
  ) {
    const data = {
      title,
      building_id,
      category_id,
      section_id,
      images,
      body,
      ...optional
    };
    return super.create(data);
  }

  update(
    id,
    optional = {
      archived: undefined,
      button_text: undefined,
      category_id: undefined,
      body: undefined,
      featured: undefined,
      images: undefined,
      images_for_delete: undefined,
      publish_date: undefined,
      publish_time: undefined,
      section_id: undefined,
      title: undefined,
      website_url: undefined
    }
  ) {
    return super.update(id, optional);
  }

  dashboard = (buildingId) =>
    new Promise((resolve, reject) => {
      if (!buildingId) throw new Error('provide_building_id');
      this.client.request(
        this.namespace,
        'dashboard',
        (error, response) => {
          if (error) {
            reject(error);
          } else {
            resolve(response?.data);
          }
        },
        { building_id: buildingId },
        Client.methods.GET
      );
    });

  archive(id) {
    return this.toggleArchived(id);
  }

  unarchive(id) {
    return this.toggleArchived(id, true);
  }

  toggleArchived(articleId, unarchive) {
    return new Promise((resolve, reject) => {
      if (!articleId) throw new Error('provide_article_id');
      this.client.request(
        this.namespace,
        unarchive ? this.unarchiveCall : this.archiveCall,
        (error, { archived }) => {
          if (error) reject(error);
          else resolve(archived);
        },
        { id: articleId },
        Client.methods.PUT
      );
    });
  }
}
